import React from 'react';
import CloseButton from 'assets/close.svg';
import { FilterBySelectOption } from '../index';

export interface RenderTagProps {
  value: string;
  onClose: () => void;
  options: FilterBySelectOption[];
  closeButtonAlt?: string;
  dataTestId?: string;
}

const defaultCloseAlt = 'close button';

export default function RenderTag({
  value,
  onClose,
  options,
  closeButtonAlt = defaultCloseAlt,
  dataTestId = 'filter-by-select-render-tag'
}: Readonly<RenderTagProps>) {
  const option = options.find(o => o.key === value);
  return (
    <div className="flex items-center mr-2">
      <div
        data-testid={dataTestId}
        className="flex items-center px-1 pl-2 gap-1 rounded border border-neutral-100 bg-neutral-100"
      >
        <div className="text-neutral-60 font-body text-xs font-semibold">
          {option?.value}
        </div>
        <button type="button" onClick={onClose}>
          <img src={CloseButton} alt={closeButtonAlt} width={16} height={16} />
        </button>
      </div>
    </div>
  );
}
